import { Box, Container, Typography } from "@mui/material";

import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import FavoriteIcon from "@mui/icons-material/Favorite";

import pricingSectionBg from "../../assets/images/pricing_section_bg.png";
import pricingSectionBgm from "../../assets/images/pricing_section_bg_m.png";
import pricingCardBg from "../../assets/images/pricing_card_bgm.png";

const pricingCategories = [
  {
    title: "Dry Cleaning",
    icon: <DryCleaningIcon />,
    services: [
      { name: "Shirts & Tops", price: "$5.25" },
      { name: "Pants & Trousers", price: "$10.45" },
      { name: "Suits (2 Piece)", price: "$22.95" },
      { name: "Blazers & Jackets", price: "$12.45" },
      { name: "Winter Coats", price: "$24.99" },
    ],
  },

  {
    title: "Laundry Service",
    icon: <LocalLaundryServiceIcon />,
    services: [
      { name: "Shirts & Tops", price: "$3.95" },
      { name: "Pants & Trousers", price: "$10.45" },
      { name: "Bed Linens", price: "From $18.95" },
      { name: "Comforters", price: "From $47.95" },
      { name: "Curtains", price: "From $30.95" },
    ],
  },

  {
    title: "Steam Ironing",
    icon: <CheckroomIcon />,
    services: [
      { name: "Shirts & Tops", price: "$3.56" },
      { name: "Pants & Trousers", price: "$9.45" },
      { name: "Suits", price: "$20.66" },
      { name: "Blazers", price: "$11.21" },
      { name: "Winter Coats", price: "$22.49" },
    ],
  },

  {
    title: "Wedding Dress Care",
    icon: <FavoriteIcon />,
    services: [
      { name: "Wedding Dress", price: "$200+" },
      { name: "Bridal Gown", price: "$200+" },
      { name: "Preservation", price: "Included" },
      { name: "Delicate Fabrics", price: "Inspection" },
      { name: "Custom Treatment", price: "Quote" },
    ],
  },
];

export default function PricingSection() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${pricingSectionBgm})`,
          md: `url(${pricingSectionBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADING */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "850px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Transparent Pricing
          </Box>

          <Typography
            sx={{
              mt: 1.5,

              fontWeight: 900,

              lineHeight: 1.1,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
              display: "block",
            }}
          >
            Affordable Rates{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Premium Results
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            Clear pricing with no hidden charges. Professional garment care and
            premium cleaning services at competitive rates.
          </Typography>
        </Box>

        {/* PRICING CARDS */}

        <Box
          sx={{
            mt: {
              xs: 5,
              md: 8,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: 2,
          }}
        >
          {pricingCategories.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 8px)",
                  lg: "0 0 calc(25% - 15px)",
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  lg: "calc(25% - 15px)",
                },

                p: {
                  xs: 1.5,
                  md: 3,
                },

                borderRadius: "30px",

                position: "relative",

                overflow: "hidden",

                backgroundImage: `
                // linear-gradient(
                // rgba(255,255,255,.95),
                // rgba(248,251,255,.88)
                // ),
                url(${pricingCardBg})
              `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(255,255,255,.8)",

                boxShadow: "0 15px 40px rgba(0,87,255,.08)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 18,

                  bottom: 18,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                },

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.15)",
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 48,
                    md: 68,
                  },

                  height: {
                    xs: 48,
                    md: 68,
                  },

                  borderRadius: "20px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  color: "#fff",

                  mb: 2.5,

                  boxShadow: "0 15px 35px rgba(0,87,255,.25)",

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 34,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  fontSize: {
                    xs: "14px",
                    md: "24px",
                  },

                  mb: 2,
                }}
              >
                {item.title}
              </Typography>

              {/* SERVICES */}

              {item.services.map((service, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    py: 1,

                    borderBottom: "1px dashed rgba(0,87,255,.12)",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#12305F",

                      fontWeight: 600,

                      fontSize: {
                        xs: "10px",
                        md: "14px",
                      },
                    }}
                  >
                    {service.name}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#0057FF",

                      fontWeight: 800,

                      fontSize: {
                        xs: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    {service.price}
                  </Typography>
                </Box>
              ))}

              {/* BOTTOM ACCENT */}

              <Box
                sx={{
                  position: "absolute",

                  left: 0,

                  right: 0,

                  bottom: 0,

                  height: "4px",

                  background: "linear-gradient(90deg,#0057FF,#1DB6FF)",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}